/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLemon2 = createReactComponent("lemon-2", "IconLemon2", [
  [
    "path",
    {
      d: "M18 4a2 2 0 0 1 1.185 3.611c1.55 2.94 .873 6.917 -1.892 9.682c-2.765 2.765 -6.743 3.442 -9.682 1.892a2 2 0 1 1 -2.796 -2.796c-1.55 -2.94 -.873 -6.917 1.892 -9.682c2.765 -2.765 6.743 -3.442 9.682 -1.892a2 2 0 0 1 1.611 -.815z",
      key: "svg-0"
    }
  ]
]);

export { IconLemon2 as default };
//# sourceMappingURL=IconLemon2.js.map
